<template>
  <div class="pagination">
    <router-link :to="prevPage" class="pagination__button pagination__item prev">
      <span class="button__wrp">
        <span class="button__icon">
          <svg class="icon"><use xlink:href="/icon/icons.svg#icon-arrow-left"></use>
          </svg>
        </span>
      </span>
    </router-link>
    <div class="pagination__list">
      <!--{{minPageCount}} - {{maxPageCount}}-->
      <router-link
        :to="{ name: router, params: { slug: $route.params.slug, page: n }}"
        class="pagination__item" v-for="n in pageCount.slice(minPageCount, pagination.current_page + 5 )" :key="n">
        <span>{{ n }}</span>
      </router-link>
    </div>
    <router-link :to="nextPage" class="pagination__button pagination__item next">
      <span class="button__wrp">
        <span class="button__icon">
          <svg class="icon">
            <use xlink:href="/icon/icons.svg#icon-arrow-right"></use>
          </svg>
        </span>
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    pagination: Object,
    router: String
  },
  computed: {
    nextPage () {
      const slug = this.$route.params.slug
      const currentPage = this.pagination.current_page
      return { name: this.router, params: { slug: slug, page: currentPage + 1 } }
    },
    prevPage () {
      const slug = this.$route.params.slug
      const currentPage = this.pagination.current_page
      return { name: this.router, params: { slug: slug, page: currentPage - 1 } }
    },
    pageCount () {
      const arr = []
      for (let i = 0; i <= this.pagination.last_page; i++) {
        arr.push(i)
      }
      return arr
    },
    minPageCount () {
      return this.pagination.current_page > 5 ? this.pagination.current_page - 4 : 1
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/pagination";
</style>
